import React from "react"
import PixelSlider from "@kit/design/pixel-slider"

export function ImageBorderRadius({ properties, update }) {
  function handleChange(value) {
    update(
      {
        imageBorderRadius: value
      },
      { localStoragePrefix: `layout-${properties.template}` }
    )
  }

  return (
    <PixelSlider
      label="Image radius"
      name="imageRadius"
      value={properties.imageBorderRadius}
      onChange={handleChange}
      min={0}
      max={24}
    />
  )
}
